import { isPlainObject, isPlainFunction, hasOwn } from './util.js';

let ErrorValid = {
    errorValid: false,
    desc: []
};

export const validateProp = (key, propOptions, propsData) => {
    const prop = propOptions[key] || {};
    const absent = !hasOwn(propsData, key);
    let value = propsData[key];
    ErrorValid.errorValid = false;
    ErrorValid.desc = [];

    // 处理type = boolean
    if (isType(Boolean, prop.$type)) {
        if (absent && !hasOwn(prop, '$default')) {
            // 不含有且无default值
            value = false;
        } else if (!isType(String, prop.$type) && (value === '')) {
            value = true;
        }
    }

    // 处理 absent=true,检索是否有默认值
    if (value === undefined) {
        value = getPropDefaultValue(prop, key);
    }

    if (process.env.NODE_ENV !== 'production') {
        assertProp(prop, key, value, absent);
    }

    if (ErrorValid.errorValid) {
        return ErrorValid;
    }

    return value;
};


/**
 * 默认值
 */
const getPropDefaultValue = (prop, key) => {
    if (!hasOwn(prop, '$default')) {
        return null;
    }
    let def = prop.$default;

    // const assertedValue  =  assertValue(prop, def)
    // if (!assertedValue.valid){
    //     process.env.NODE_ENV !== 'production' && console.error(`错误提示：字段("${key}:${prop.$default}")default值，与type类型不匹配`)
    //      ErrorValid.errorValid = true
    //      ErrorValid.desc.push(`错误提示：字段("${key}:${prop.$default}")default值，与type类型不匹配`)
    //      return null
    // }
    return typeof def === 'function' && prop.$type !== Function ? def() : def;
};


/**
 * prop
 * name = key
 * value = value
 *absent
 */
const assertProp = (prop, name, value, absent) => {
    if (prop.$required && absent) {
        // required = true  无字段
        console.error(`错误提示：字段("${name}")是必填字段，丢失，请检查`);
        ErrorValid.errorValid = true;
        ErrorValid.desc.push(`错误提示：字段("${name}")是必填字段，丢失，请检查`);
        return;
    }

    if (value == null && !prop.$required) {
        return;
    }

    const assertedValue = assertValue(prop, value);

    if (!assertedValue.valid) {
        // 类型不匹配：字段 ${name}
        console.error(`错误提示：字段("${name}:${value}")原类型${assertedValue.expectedTypes}与现在不匹配,请检查`);
        ErrorValid.errorValid = true;
        ErrorValid.desc.push(`错误提示：字段("${name}:${value}")原类型${assertedValue.expectedTypes}与现在不匹配,请检查`);
        return;
    }

    const validator = prop.$validator;
    if (validator) {
        if (!isPlainFunction(validator) || !validator(value)) {
            console.error(`错误提示：字段("${name}")自定义validator错误,请检查`);
            ErrorValid.errorValid = true;
            ErrorValid.desc.push(`错误提示：字段("${name}")自定义validator错误,请检查`);
            return false;
        }
    }
};

const assertValue = (prop, value) => {
    let type = prop.$type;
    let valid = !type || type === true;
    const expectedTypes = [];
    if (type) {
        if (!Array.isArray(type)) {
            type = [type];
        }
        for (let i = 0; i < type.length && !valid; i++) {
            const assertedType = assertType(value, type[i]);
            expectedTypes.push(assertedType.expectedType || ''); // [String,Number]
            valid = assertedType.valid;
        }
    }
    return {
        valid,
        expectedTypes
    };
};


/**
 * Number == number
 * 对比value 是否是对应的类型
 */
const assertType = (value, type) => {
    let valid;
    let expectedType = getType(type);
    if (expectedType === 'String') {
        valid = typeof value === (expectedType = 'string');
    } else if (expectedType === 'Number') {
        valid = typeof value === (expectedType = 'number');
    } else if (expectedType === 'Boolean') {
        valid = typeof value === (expectedType = 'boolean');
    } else if (expectedType === 'Function') {
        valid = typeof value === (expectedType = 'function');
    } else if (expectedType === 'Object') {
        valid = isPlainObject(value);
    } else if (expectedType === 'Array') {
        valid = Array.isArray(value);
    } else {
        valid = value instanceof type;
    }
    return {
        valid,
        expectedType
    };
};


/**
 * 对比类型
 *type
 *fn
 * return /true (Number) false（Number，number）
 */
const isType = (type, fn) => {
    if (!Array.isArray(fn)) {
        return getType(fn) === getType(type);
    }
    for (let i = 0, len = fn.length; i < len; i++) {
        if (getType(fn[i]) === getType(type)) {
            return true;
        }
    }
    return false;
};

/**
 * fn: Number String Object
 * return Number String Object / undefined
 */
const getType = (fn) => {
    const match = fn && fn.toString().match(/^\s*function (\w+)/);
    return match && match[1];
};



// WEBPACK FOOTER //
// ./src/resource-api/core/ports.js